import PropTypes from "prop-types";
import React from "react";
import Textarea from "react-textarea-autosize";
import styled, { css } from "styled-components";
import { layout } from "../../../main/styles/layout";

const Seller13 = ({
  design,
  agent,
  AgentInfo,
  Title,
  Subtitle,
  PrimaryInput,
  Footer
}) => {
  const { backgroundUrl } = design;

  return (
    <LandingPageWrapper>
      <AgentInfoWrapper>
        <AgentInfo agent={agent} design={design} />
      </AgentInfoWrapper>
      <ContentWrapper>
        <MainContent>
          <Title
            TitleWrapper={TitleWrapper}
            TitleInput={TitleInput}
            TitleText={TitleText}
            design={design}
          />
          <PrimaryInput />
          <Subtitle
            SubtitleWrapper={SubtitleWrapper}
            SubtitleInput={SubtitleInput}
            SubtitleText={SubtitleText}
            design={design}
          />
        </MainContent>
        <Illustration bgImg={backgroundUrl} />
        <FooterWrapper>
          <Footer
            dreNumber={agent.dreNumber}
            website={agent.website}
            design={design}
          />
        </FooterWrapper>
      </ContentWrapper>
    </LandingPageWrapper>
  );
};

Seller13.propTypes = {
  design: PropTypes.object.isRequired,
  agent: PropTypes.object.isRequired,
  AgentInfo: PropTypes.elementType.isRequired,
  Title: PropTypes.elementType.isRequired,
  Subtitle: PropTypes.elementType.isRequired,
  PrimaryInput: PropTypes.elementType.isRequired,
  Footer: PropTypes.elementType.isRequired
};

// Styled Components
const LandingPageWrapper = styled.div`
  ${layout("column", "center")}
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #efd7bf;
`;

const AgentInfoWrapper = styled.div`
  z-index: 1;
`;

const ContentWrapper = styled.div`
  ${layout("column", "center")}
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 0;
  background-color: #fcf8ef;
`;

const MainContent = styled.div`
  ${layout("column", "center")}
  width: 100%;
  max-width: 1200px;
  height: auto;
  padding: 144px 30px 0 30px;
  box-sizing: border-box;
  @media (max-width: 600px) {
    padding: 188px 15px 0 15px;
  }
`;

const Illustration = styled.div`
  height: 178px;
  width: 100%;
  background-position: bottom;
  background-repeat: no-repeat;
  background-image: ${(props) => `url(${props.bgImg})`};
  @media (max-width: 599px) {
    background-size: cover;
    background-position: center;
  }
`;

const FooterWrapper = styled.div`
  ${layout("row", "center", "center")}
  height: 80px;
  width: 100%;
  background-color: #efd7bf;
  border-top: 2px solid #6c5f53;
`;

// Child Components passed as props
const TitleWrapper = styled.div`
  ${layout("row", "center", "center")}
  margin-bottom: 28px;
  padding: 24px 40px;
  box-sizing: border-box;
  width: 100%;
  ${(props) =>
    props.customizable &&
    css`
      width: auto;
      border: 1px dashed #00e6c3;
      &:hover {
        border: 1px solid #00e6c3;
      }
    `}
  @media (max-width: 599px) {
    width: 100%;
    margin-bottom: 30px;
    padding: 4px 8px;
  }
`;

const TitleInput = styled(Textarea)`
  font-size: 40px;
  line-height: 52px;
  min-height: 52px;
  font-weight: 600;
  outline: none;
  border: none;
  width: 100%;
  max-width: 1140px;
  text-align: center;
  resize: none;
  background: transparent;
  overflow-wrap: break-word;
  @media (max-width: 599px) {
    font-size: 26px;
    line-height: 36px;
    font-weight: 400;
  }
`;

const TitleText = styled.h1`
  font-size: 40px;
  line-height: 52px;
  font-weight: 600;
  width: 100%;
  max-width: 1140px;
  text-align: center;
  resize: none;
  overflow-wrap: break-word;
  @media (max-width: 599px) {
    font-size: 26px;
    line-height: 36px;
    font-weight: 400;
  }
`;

const SubtitleWrapper = styled.div`
  ${layout("row", "center", "center")}
  width: 100%;
  margin-bottom: 30px;
  padding: 20px 24px;
  box-sizing: border-box;
  ${(props) =>
    props.customizable &&
    css`
      width: auto;
      border: 1px dashed #00e6c3;
      &:hover {
        border: 1px solid #00e6c3;
      }
    `}
  @media (max-width: 599px) {
    padding: 0 8px;
    margin-bottom: 0;
  }
`;

const SubtitleInput = styled(Textarea)`
  font-size: 15px;
  line-height: 20px;
  min-height: 20px;
  border: none;
  outline: none;
  width: 100%;
  max-width: 1140px;
  resize: none;
  text-align: center;
  background: transparent;
  overflow-wrap: break-word;
  @media (max-width: 599px) {
    font-size: 13px;
    line-height: 20px;
  }
`;

const SubtitleText = styled.h1`
  font-size: 15px;
  line-height: 20px;
  width: 100%;
  max-width: 1140px;
  resize: none;
  text-align: center;
  overflow-wrap: break-word;
  @media (max-width: 599px) {
    font-size: 13px;
    line-height: 20px;
  }
`;

export default Seller13;
